/**
 * Ministry relationship + connection enums. Source of truth for this
 * data-layer. Mirror any DB-enum migration changes
 * (ministry_people.relationship_type CHECK constraint) here in the same
 * commit. Consumed by queries/ministry.js (which re-exports for backwards
 * compat) and by any UI component that needs labels or ring mapping.
 */

// ── Ring auto-mapping ───────────────────────────────────────────
// Matches the enum on ministry_people.relationship_type.
// Changing this list requires a matching migration update.
export const RELATIONSHIP_RING_MAP = {
  family: 1,
  spouse: 1,
  close_friend: 2,
  small_group: 2,
  mentor: 2,
  friend: 3,
  coworker: 3,
  neighbor: 3,
  acquaintance: 3,
}

export const RELATIONSHIP_LABELS = {
  family: 'Family',
  spouse: 'Spouse',
  close_friend: 'Close Friend',
  small_group: 'Small Group',
  mentor: 'Mentor / Mentee',
  friend: 'Friend',
  coworker: 'Coworker',
  neighbor: 'Neighbor',
  acquaintance: 'Acquaintance',
}

export const CONNECTION_TYPE_LABELS = {
  family: 'Family',
  spouse_partner: 'Spouse / Partner',
  friend: 'Friend',
  romantic: 'Romantic Interest',
  met_through: 'Met Through',
  works_with: 'Works With',
  church_with: 'Church With',
  lives_near: 'Lives Near',
  other: 'Other',
}

export function ringForRelationship(rel) {
  return RELATIONSHIP_RING_MAP[rel] ?? 3
}
